import t from '../../translate'
import Field from "../../components/Field";
import CountrySelectField from './CountrySelectField'

function preventCopyPaste(e) {
  // Prevent Ctrl+C, Ctrl+V, Ctrl+X
  if ((e.ctrlKey || e.metaKey) && (e.key === 'c' || e.key === 'v' || e.key === 'x')) {
      e.preventDefault();
      return false;
  }
  // Prevent right click
  if (e.type === 'contextmenu') {
      e.preventDefault();
      return false;
  }
  return true;
}

export function AddressForm ({countries}) {
  return <>
    <div className="form-row">
      <div className="big-field">
        <label htmlFor="data.personal.address.street">{t(
          'data.personal.address.street')}*</label>
        <Field id="data.personal.address.street"
               name="data.personal.address.street" type="text" required/>
      </div>
      <div className="middle-field">
        <label htmlFor="data.personal.address.houseNumber">{t(
          'data.personal.address.houseNumber')}*</label>
        <Field id="data.personal.address.houseNumber" name="data.personal.address.houseNumber" type="text" required/>
      </div>
    </div>
    <div className="form-row">
      <div className="big-field">
        <label htmlFor={'data.personal.address.department'}>{t(
          'data.personal.address.department')}</label>
        <Field id={'data.personal.address.department'} name={'data.personal.address.department'} type={'text'}/>
      </div>
    </div>
    <div className="form-row">
      <div className="middle-field">
        <label htmlFor="data.personal.address.postalCode">{t(
          'data.personal.address.postalCode')}*</label>
        <Field id="data.personal.address.postalCode" name="data.personal.address.postalCode" type="text" required/>
      </div>
      <div className="big-field">
        <label htmlFor="data.personal.address.city">{t(
          'data.personal.address.city')}*</label>
        <Field id="data.personal.address.city" name="data.personal.address.city" type="text" required/>
      </div>
    </div>
    <div className="form-row">
      <div className="form-col">
        <label htmlFor="data.personal.address.country">{t(
          'data.personal.address.country')}*</label>
        <CountrySelectField countries={countries} id="data.personal.address.country" name="data.personal.address.country" required/>
      </div>
      <div className={'form-col'}>
        <label htmlFor={'data.personal.address.phone'}>{t(
          'data.personal.address.phone')}*</label>
        <Field type="text" id="data.personal.address.phone"
              name="data.personal.address.phone"/>
      </div>
    </div>
    {/* <div className={'form-row'}>
      <div className={'form-col'}>
        <label htmlFor={'data.personal.address.phone'}>{t(
          'data.personal.address.phone')}*</label>
        <Field type="text" id="data.personal.address.phone"
              name="data.personal.address.phone"/>
      </div>
    </div> */}
    <div className={'form-row'}>
      <div className={'form-col'}>
        <label htmlFor={'data.personal.address.email'}>{t(
          'data.personal.address.email')}*</label>
        <Field type="text" id="data.personal.address.email"
               name="data.personal.address.email"
               onKeyDown={preventCopyPaste}
               onContextMenu={(e) => e.preventDefault()}
               onPaste={(e) => e.preventDefault()}
               onDrop={(e) => e.preventDefault()}
               onDragOver={(e) => e.preventDefault()}
               required/>
      </div>
      <div className={'form-col'}>
        <label htmlFor={'data.personal.address.emailConfirm'}>{t(
          'data.personal.address.emailConfirm')}*</label>
        <Field type="text" id="data.personal.address.emailConfirm"
               name="data.personal.address.emailConfirm"
               onKeyDown={preventCopyPaste}
               onContextMenu={(e) => e.preventDefault()}
               onPaste={(e) => e.preventDefault()}
               onDrop={(e) => e.preventDefault()}
               onDragOver={(e) => e.preventDefault()}
               required/>
      </div>
    </div>
  </>
}